/**
 * Membersihkan pengenal internal dari pesan server sebelum ditampilkan — MURNI.
 *
 * ADA KARENA layar penolakan izin berbunyi, apa adanya kepada kurir:
 *
 *     "Tidak punya izin untuk tindakan ini (workforce.worker.read)."
 *
 * Bagian dalam kurung itu nama izin di dalam program. Bagi orang yang membukanya di jalan ia
 * bukan penjelasan melainkan kebisingan — dan lebih buruk, ia terbaca seperti kode kesalahan yang
 * seolah menuntut dilaporkan, padahal kalimat di bawahnya sudah menyebut tindakan yang benar
 * ("Hubungi admin organisasi").
 *
 * TIDAK membuang seluruh pesan server, dan itu keputusannya. Banyak pesan justru satu-satunya
 * keterangan yang berguna — "Check-in ditolak — masih ada sesi terbuka." menjelaskan persis apa
 * yang terjadi, dan menghapusnya demi kerapian akan meninggalkan orang tanpa jawaban. Yang
 * dibuang hanya pengenal ber-titik yang jelas milik mesin.
 *
 * Server TETAP mengirimkannya, dan itu disengaja: jejak audit dan log tetap menyebut izin mana
 * yang ditolak. Yang berubah hanya apa yang sampai ke mata pemakai.
 */

/**
 * Pola pengenal internal: satu atau lebih segmen ber-titik, huruf kecil, dalam kurung di ujung
 * kalimat — persis bentuk `(workforce.worker.read)`.
 *
 * SENGAJA sempit. Kurung yang berisi kalimat manusia ("(opsional)", "(radius 150 m)") tidak
 * tersentuh, dan itu diuji.
 */
const PENGENAL_INTERNAL = /\s*\((?:[a-z][a-z0-9_]*)(?:\.[a-z][a-z0-9_]*)+\)/g;

export function pesanTanpaJargon(message: string): string {
  const bersih = message.replace(PENGENAL_INTERNAL, '').trim();
  /*
   * Bila pembersihan menyisakan kalimat kosong, pesan ASLI dikembalikan.
   *
   * Kotak galat tanpa kalimat lebih buruk daripada kalimat yang mengandung jargon: yang pertama
   * terbaca seperti layar yang rusak, yang kedua setidaknya memberi tahu ada sesuatu.
   */
  return bersih.length === 0 ? message : bersih;
}
